<template>
	<v-menu
		left
		bottom
		absolute
		min-width="500"
		content-class="men"
		:value="showMenu"
		:position-y="menuXY.y"
		:position-x="menuXY.x"
		:close-on-content-click="false"
	>
		<div class="formatting pa-2">
			<div class="title">{{ title }}</div>
			<CombinedInputFieldDataMenu
				class="width-100"
				noPrefix
				dontOpenOnSlash
				preventTables
				:value.sync="localContent"
				:textAreaMode="false"
				:dontShowInsertData="dontShowInsertData"
				:valuesTypes="ITEM_ONLY_ALLOWED_VALUE_TYPES"
				:suffixStyle="{ 'margin-right': '5px !important', 'margin-top': '0px !important' }"
				@content-updated="onEnter"
			/>
			<div class="flex-row flex-centerize mt-2">
				<AnemicButton class="mr-4 save-button" @click="saveContent()">Save</AnemicButton>
				<AnemicButton class="cancel-button" @click="$emit('cancel')">Cancel</AnemicButton>
			</div>
		</div>
	</v-menu>
</template>

<script>
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import { ITEM_ONLY_ALLOWED_VALUE_TYPES } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const.js';

export default {
	name: 'FormattingDialog',
	props: {
		content: { type: String },
		insertedDataSource: { type: String },
		editor: { type: Object },
		boundingClientRect: { type: DOMRect },
		title: { type: String },
		dontShowInsertData: { type: Boolean },
	},
	components: {
		CombinedInputFieldDataMenu,
	},
	computed: {
		localContent: {
			get() {
				return this.localCache || '';
			},
			set(value) {
				this.localCache = value;
			},
		},
	},
	watch: {
		boundingClientRect: {
			handler(newV) {
				if (newV) {
					this.menuXY = { x: newV.x, y: newV.y + 62 };
				}
			},
			immediate: true,
		},
	},
	methods: {
		saveContent() {
			const content = this.localContent.replaceAll('\n', '');
			this.$emit('saveContent', { content, plySource: content });
		},
		onEnter(key) {
			if (key === 'Enter') {
				this.saveContent();
			}
		},
	},
	mounted() {
		const { insertedDataSource, content } = this;
		this.localCache = insertedDataSource ? insertedDataSource : content;
	},
	data() {
		return {
			localCache: '',
			showMenu: true,
			menuXY: { x: 0, y: 0 },
			ITEM_ONLY_ALLOWED_VALUE_TYPES,
		};
	},
};
</script>

<style lang="scss" scoped>
.formatting {
	background: var(--bg-color);

	.title {
	}
}

.save-button {
	width: 100px;
}
.cancel-button {
	width: 100px;
}
</style>
